export default __webpack_public_path__ + "static/feature_mb_02-4dff26dfb3a4183fc3e443eaf8c8a80f.png";